"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _IconButton = _interopRequireDefault(require("material-ui/IconButton"));
var _close = _interopRequireDefault(require("material-ui/svg-icons/navigation/close"));
var _error = _interopRequireDefault(require("material-ui/svg-icons/alert/error"));
var _checkCircle = _interopRequireDefault(require("material-ui/svg-icons/action/check-circle"));
var _brightness = _interopRequireDefault(require("material-ui/svg-icons/image/brightness-1"));
var _reactSvgGauge = _interopRequireDefault(require("react-svg-gauge"));
var _map2 = _interopRequireDefault(require("lodash/map"));
require("./ColonyKit.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var fadeTransitionStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  }
};
var zoom235TransitionStyles = {
  entering: {
    width: 0,
    height: 0,
    opacity: 0
  },
  entered: {
    width: 235,
    height: 235,
    opacity: 1
  }
};
var ColonyKitGame = /*#__PURE__*/function (_Component) {
  _inherits(ColonyKitGame, _Component);
  var _super = _createSuper(ColonyKitGame);
  function ColonyKitGame(props) {
    var _this;
    _classCallCheck(this, ColonyKitGame);
    _this = _super.call(this, props);
    _this.state = {
      spaces: {
        0: {},
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
        9: {},
        10: {},
        11: {}
      },
      items: _this.props.items,
      feedbackTitle: _this.props.initialFeedbackTitle,
      feedbackMsg: _this.props.initialFeedbackMsg,
      gaugeValue: 0,
      gaugeWidth: 300,
      gaugeMobileWidth: 200,
      gaugeHeight: 200,
      gaugeColor: "#bc932f",
      activeModal: false,
      activeTooltipModal: false,
      tooltipIsSuitable: null,
      tooltipFeedbackMsg: null,
      tooltipTitle: null
    };
    _this.resizingWindow = _this.resizingWindow.bind(_assertThisInitialized(_this));
    _this.processAnswer = _this.processAnswer.bind(_assertThisInitialized(_this));
    _this.displayFeedback = _this.displayFeedback.bind(_assertThisInitialized(_this));
    _this.hideAllTooltips = _this.hideAllTooltips.bind(_assertThisInitialized(_this));
    _this.calculateRightAnswers = _this.calculateRightAnswers.bind(_assertThisInitialized(_this));
    _this.chooseFeedback = _this.chooseFeedback.bind(_assertThisInitialized(_this));
    _this.updateGaugeColor = _this.updateGaugeColor.bind(_assertThisInitialized(_this));
    _this.openItemsModal = _this.openItemsModal.bind(_assertThisInitialized(_this));
    _this.openTooltipModal = _this.openTooltipModal.bind(_assertThisInitialized(_this));
    _this.closeTooltipModal = _this.closeTooltipModal.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ColonyKitGame, [{
    key: "openItemsModal",
    value: function openItemsModal(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.setState({
        activeModal: true
      });
    }
  }, {
    key: "openTooltipModal",
    value: function openTooltipModal(e, itemData) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.setState({
        activeTooltipModal: true
      });
      if (itemData) {
        this.setState({
          tooltipIsSuitable: itemData.isSuitable,
          tooltipFeedbackMsg: itemData.message,
          tooltipTitle: itemData.title
        });
      }
    }
  }, {
    key: "closeItemsModal",
    value: function closeItemsModal(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.setState({
        activeModal: false
      });
    }
  }, {
    key: "closeTooltipModal",
    value: function closeTooltipModal(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.setState({
        activeTooltipModal: false
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var interval = setInterval(function () {
        var gaugeContainerW = _this2.gaugeContainer ? _this2.gaugeContainer.clientWidth : null;
        var gaugeContainerH = _this2.infoContainer ? _this2.infoContainer.clientHeight : null;
        var gaugeMobileContainerW = _this2.gaugeMobileContainer ? _this2.gaugeMobileContainer.clientWidth : null;
        if (gaugeContainerW && gaugeContainerH) {
          _this2.setState({
            gaugeWidth: gaugeContainerW,
            gaugeHeight: gaugeContainerH
          });
          clearInterval(interval);
        }
        if (gaugeMobileContainerW) {
          _this2.setState({
            gaugeMobileWidth: gaugeMobileContainerW
          });
          clearInterval(interval);
        }
      }, 300);
      window.addEventListener("resize", this.resizingWindow);
      if (window.innerWidth < 992) this.setState({
        isMobile: true
      });else this.setState({
        isMobile: false
      });
    }
  }, {
    key: "resizingWindow",
    value: function resizingWindow() {
      var gaugeContainerW = this.gaugeContainer ? this.gaugeContainer.clientWidth : null;
      var gaugeContainerH = this.infoContainer ? this.infoContainer.clientHeight : null;
      // console.log('CLient Height', this.infoContainer.clientHeight);
      var gaugeMobileContainerW = this.gaugeMobileContainer ? this.gaugeMobileContainer.clientWidth : null;
      if (gaugeContainerW && gaugeContainerH) {
        this.setState({
          gaugeWidth: gaugeContainerW,
          gaugeHeight: gaugeContainerH
        });
      }
      if (gaugeMobileContainerW) {
        this.setState({
          gaugeMobileWidth: gaugeMobileContainerW
        });
      }
      if (window.innerWidth < 992) this.setState({
        isMobile: true
      });else this.setState({
        isMobile: false
      });
    }
  }, {
    key: "hideAllTooltips",
    value: function hideAllTooltips() {
      console.log('hide all tooltips');
      var spaces = this.state.spaces;
      (0, _map2["default"])(this.state.spaces, function (space, key) {
        spaces[key].displayFeedback = false;
      });
      this.setState({
        spaces: spaces
      });
    }
  }, {
    key: "calculateRightAnswers",
    value: function calculateRightAnswers() {
      // Returns 0 if mixed - 1 if all good - -1 if all false
      var hasWrong = false,
        hasRight = false;
      (0, _map2["default"])(this.state.spaces, function (space) {
        if (typeof space.isSuitable !== 'undefined' && space.isSuitable) {
          hasRight = true;
        } else if (typeof space.isSuitable !== 'undefined') {
          hasWrong = true;
        }
      });
      if (hasRight && hasWrong) return 0;else if (hasRight) return 1;else if (hasWrong) return -1;else return false;
    }
  }, {
    key: "chooseFeedback",
    value: function chooseFeedback() {
      var answers = this.calculateRightAnswers();
      if (!answers) return {
        heading: this.props.initialFeedbackTitle,
        message: this.props.initialFeedbackMsg
      };
      var gaugeLevel = this.state.gaugeValue;
      var successLevel = answers === 0 ? 'mixed' : answers === 1 ? 'allgood' : 'allbad';
      var feedbackMessages = this.props.feedbackMessages[successLevel];
      // console.log('Gauge level', gaugeLevel);
      // If gauge is finished
      if (gaugeLevel > 98) {
        return {
          heading: this.props.finalFeedbackTitle,
          message: this.props.finalFeedbackMsg
        };
      }
      var feedbackPool = [];
      var controlValue;
      if (gaugeLevel < 9) {
        controlValue = 0;
      } else if (gaugeLevel < 26) {
        controlValue = 25;
      } else if (gaugeLevel < 51) {
        controlValue = 50;
      } else {
        controlValue = 75;
      }
      (0, _map2["default"])(feedbackMessages, function (msg) {
        if (msg.completion === controlValue) feedbackPool.push(msg);
      });
      console.log('choosing feedback - answers', answers, ' - gauge', gaugeLevel, ' - successLevel', successLevel);
      var shuffleArray = function shuffleArray(arr) {
        return arr.sort(function () {
          return Math.random() - 0.5;
        });
      };
      var shuffledArray = shuffleArray(feedbackPool);
      console.log('The feedback pool is ', feedbackPool);
      return shuffledArray[0];
    }
  }, {
    key: "processAnswer",
    value: function processAnswer(id, e) {
      var _this3 = this;
      e.preventDefault();
      e.stopPropagation();
      this.closeItemsModal();
      this.hideAllTooltips();
      var item = this.props.items[id];

      // Find last added key
      var firstFreeKey = 0;
      while (typeof this.state.spaces[firstFreeKey] !== 'undefined' && typeof this.state.spaces[firstFreeKey].title !== 'undefined') {
        firstFreeKey++;
      }
      if (firstFreeKey === Object.keys(this.state.spaces).length) {
        return;
      }

      // Updating Gauge
      var newGaugeValue;
      if (this.state.gaugeValue > 5 && !item.isSuitable) {
        newGaugeValue = this.state.gaugeValue - 8.33;
      } else if (item.isSuitable) {
        newGaugeValue = this.state.gaugeValue + 8.33;
      } else {
        newGaugeValue = 0;
      }
      this.setState({
        gaugeValue: newGaugeValue
      });
      this.updateGaugeColor(newGaugeValue);

      // Mobile version - display modal
      if (this.state.isMobile) {
        this.setState({
          tooltipIsSuitable: item.isSuitable,
          tooltipFeedbackMsg: item.feedbackMsg,
          tooltipTitle: item.title,
          activeTooltipModal: true
        });
      }
      this.setState({
        spaces: _objectSpread(_objectSpread({}, this.state.spaces), {}, _defineProperty({}, firstFreeKey, item)),
        items: _objectSpread(_objectSpread({}, this.state.items), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, this.state.items[id]), {}, {
          used: true
        })))
      });
      setTimeout(function () {
        _this3.makeImageVisible(firstFreeKey);
        var feedback = _this3.chooseFeedback();
        _this3.setState({
          feedbackMsg: feedback.message,
          feedbackTitle: feedback.heading
        });
      }, 400);
      setTimeout(function () {
        _this3.displayFeedback(firstFreeKey);
      }, 800);
      setTimeout(function () {
        _this3.hideAllTooltips();
      }, 6000);
    }
  }, {
    key: "makeImageVisible",
    value: function makeImageVisible(key) {
      var isAlreadyVisible = this.state.spaces[key].imgVisible;
      this.hideAllTooltips();
      if (!isAlreadyVisible) {
        this.setState({
          spaces: _objectSpread(_objectSpread({}, this.state.spaces), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, this.state.spaces[key]), {}, {
            imgVisible: true
          })))
        });
      }
    }
  }, {
    key: "updateGaugeColor",
    value: function updateGaugeColor(newGaugeValue) {
      var newGaugeColor;
      if (newGaugeValue < 26) {
        newGaugeColor = "#a64a1e";
      } else if (newGaugeValue < 99) {
        newGaugeColor = "#bc932f";
      } else {
        newGaugeColor = "#528e39";
      }
      this.setState({
        gaugeColor: newGaugeColor
      });
    }
  }, {
    key: "removeItem",
    value: function removeItem(id, e) {
      var _this4 = this;
      e.preventDefault();
      e.stopPropagation();
      this.hideAllTooltips();
      this.closeTooltipModal();

      // Find key in spaces
      var removedKey;
      var remainingItems = 0;
      (0, _map2["default"])(this.state.spaces, function (space, key) {
        if (typeof space.id === 'undefined') {
          remainingItems++;
        }
        if (space.id === id) {
          removedKey = key;
        }
      });
      if (!removedKey) return;
      console.log('removeItem - remaining', remainingItems);
      // Update Gauge
      // If it is the last item
      var itemWasSuitable = this.state.items[id].isSuitable;
      console.log('deleting item that was suiteable', itemWasSuitable);
      var newGaugeValue;
      if (remainingItems >= 11) {
        newGaugeValue = 0;
      } else if (itemWasSuitable) {
        newGaugeValue = this.state.gaugeValue - 8.33;
      } else if (!itemWasSuitable) {
        newGaugeValue = this.state.gaugeValue + 8.33;
      }
      this.updateGaugeColor(newGaugeValue);
      this.setState({
        gaugeValue: newGaugeValue,
        spaces: _objectSpread(_objectSpread({}, this.state.spaces), {}, _defineProperty({}, removedKey, {})),
        items: _objectSpread(_objectSpread({}, this.state.items), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, this.state.items[id]), {}, {
          used: false
        })))
      });
      setTimeout(function () {
        var feedback = _this4.chooseFeedback();
        _this4.setState({
          feedbackMsg: feedback.message,
          feedbackTitle: feedback.heading
        });
      }, 400);
    }
  }, {
    key: "displayFeedback",
    value: function displayFeedback(key, e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      var isAlreadyDisplayed = this.state.spaces[key].displayFeedback;
      this.hideAllTooltips();
      if (!isAlreadyDisplayed) {
        console.log('displaying feedback for', key);
        this.setState({
          spaces: _objectSpread(_objectSpread({}, this.state.spaces), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, this.state.spaces[key]), {}, {
            displayFeedback: true
          })))
        });
      }
    }
  }, {
    key: "backgroundClick",
    value: function backgroundClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.hideAllTooltips();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "colonykit-game-container",
        onClick: function onClick(e) {
          _this5.backgroundClick(e);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "mobile-sidebar"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "gauge-container",
        ref: function ref(input) {
          _this5.gaugeMobileContainer = input;
        }
      }, this.state.isMobile ? /*#__PURE__*/_react["default"].createElement(_reactSvgGauge["default"], {
        id: "mobile",
        value: this.state.gaugeValue,
        label: "",
        width: this.state.gaugeMobileWidth,
        height: this.state.gaugeMobileWidth / 2,
        color: this.state.gaugeColor,
        backgroundColor: "#e2d2ad",
        valueLabelStyle: {
          display: "none"
        },
        minMaxLabelStyle: {
          display: "none"
        }
      }) : null), /*#__PURE__*/_react["default"].createElement("h1", null, "My Colony Kit"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "status-container"
      }, /*#__PURE__*/_react["default"].createElement("h2", null, this.state.feedbackTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.state.feedbackMsg)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "button-container"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "colony-button lighter",
        onClick: function onClick(e) {
          _this5.openItemsModal(e);
        }
      }, "ADD MORE"))), this.state.activeTooltipModal ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "mobile-modal"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "feedback-popup-bg"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "feedback-icon"
      }, this.state.tooltipIsSuitable ? /*#__PURE__*/_react["default"].createElement(_checkCircle["default"], {
        color: "#dd602b",
        style: {
          width: 60,
          height: 60
        }
      }) : /*#__PURE__*/_react["default"].createElement(_error["default"], {
        color: "#dd602b",
        style: {
          width: 60,
          height: 60
        }
      })), /*#__PURE__*/_react["default"].createElement("h2", null, this.state.tooltipTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.state.tooltipFeedbackMsg)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-close"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "colony-button",
        onClick: function onClick(e) {
          _this5.closeTooltipModal(e);
        }
      }, "OKAY"))) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "available-items-container ".concat(this.state.activeModal ? 'active-modal' : '')
      }, this.state.items && (0, _map2["default"])(this.state.items, function (item) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "available-item ".concat(item.used ? 'used' : ''),
          key: item.id,
          onClick: !item.used ? function (e) {
            return _this5.processAnswer(item.id, e);
          } : null
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: item.imgSrc
        }), /*#__PURE__*/_react["default"].createElement("label", null, item.title));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-close"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "colony-button",
        onClick: function onClick(e) {
          _this5.closeItemsModal(e);
        }
      }, "Cancel"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "right-container"
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "desktopH1"
      }, "My Colony Kit"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "selected-items-container"
      }, (0, _map2["default"])(this.state.spaces, function (space, key) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "selected-item ".concat(space.displayFeedback ? 'display-feedback' : ''),
          key: key
        }, typeof space.isSuitable !== 'undefined' && !space.isSuitable ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "error-icon",
          onClick: _this5.state.isMobile ? function (e) {
            return _this5.openTooltipModal(e, {
              message: space.feedbackMsg,
              title: space.title,
              isSuitable: space.isSuitable
            });
          } : function (e) {
            _this5.displayFeedback(key, e);
          }
        }, /*#__PURE__*/_react["default"].createElement(_error["default"], {
          color: "#933318",
          style: {
            width: 30,
            height: 30
          }
        })) : null, typeof space.isSuitable !== 'undefined' && !space.isSuitable ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "error-icon-back"
        }, /*#__PURE__*/_react["default"].createElement(_brightness["default"], {
          color: "white",
          style: {
            width: 32,
            height: 32
          }
        })) : null, typeof space.imgSrc !== 'undefined' ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "image-container"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: space.imgSrc,
          onClick: _this5.state.isMobile ? function (e) {
            return _this5.openTooltipModal(e, {
              message: space.feedbackMsg,
              title: space.title,
              isSuitable: space.isSuitable
            });
          } : function (e) {
            _this5.displayFeedback(key, e);
          },
          className: "".concat(space.imgVisible ? 'visible' : '')
        })) : null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "title-label"
        }, typeof space.title !== 'undefined' ? space.title : null), typeof space.title !== 'undefined' ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          style: {
            width: 30,
            height: 30,
            padding: 0
          },
          onClick: function onClick(e) {
            _this5.removeItem(space.id, e);
          }
        }, /*#__PURE__*/_react["default"].createElement(_close["default"], {
          color: "#a99c7f"
        })) : null, typeof space.title !== 'undefined' ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "feedback-popup"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "feedback-popup-bg"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "feedback-icon"
        }, space.isSuitable ? /*#__PURE__*/_react["default"].createElement(_checkCircle["default"], {
          color: "#dd602b",
          style: {
            width: 60,
            height: 60
          }
        }) : /*#__PURE__*/_react["default"].createElement(_error["default"], {
          color: "#dd602b",
          style: {
            width: 60,
            height: 60
          }
        })), /*#__PURE__*/_react["default"].createElement("h2", null, space.title), /*#__PURE__*/_react["default"].createElement("p", null, space.feedbackMsg))) : null));
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "info-container",
        ref: function ref(input) {
          _this5.infoContainer = input;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "gauge-container",
        ref: function ref(input) {
          _this5.gaugeContainer = input;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "relative-container"
      }, !this.state.isMobile ? /*#__PURE__*/_react["default"].createElement(_reactSvgGauge["default"], {
        id: "desktop",
        value: this.state.gaugeValue,
        label: "",
        width: this.state.gaugeWidth,
        height: this.state.gaugeHeight,
        color: this.state.gaugeColor,
        backgroundColor: "#e2d2ad",
        valueLabelStyle: {
          display: "none"
        },
        minMaxLabelStyle: {
          display: "none"
        }
      }) : null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "status-container"
      }, /*#__PURE__*/_react["default"].createElement("h2", null, this.state.feedbackTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.state.feedbackMsg)))));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.resizingWindow);
    }
  }]);
  return ColonyKitGame;
}(_react.Component);
ColonyKitGame.defaultProps = {};
ColonyKitGame.propTypes = {
  items: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  feedbackMessages: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  initialFeedbackMsg: _propTypes["default"].string,
  initialFeedbackTitle: _propTypes["default"].string,
  finalFeedbackMsg: _propTypes["default"].string,
  finalFeedbackTitle: _propTypes["default"].string
};
var _default = ColonyKitGame;
exports["default"] = _default;